import { render, staticRenderFns } from "./TabelAllcation.vue?vue&type=template&id=506e9789&scoped=true"
import script from "./TabelAllcation.vue?vue&type=script&lang=js"
export * from "./TabelAllcation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e9789",
  null
  
)

export default component.exports